import React, { useEffect, useState, useMemo } from 'react';
import StepLevelBlocksViewer from './StepLevelBlocks'
import { fetchSingleObligationPayload } from './utils/payload'
import { toast } from 'react-toastify';
import TopHeaderViewer from './TopHeader';
import AuditTrailViewer from './AuditTrail'
import SideBarViewer from './SideBar'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import useStyles from './style';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';


const ObligationViewer = (props) => {
  const { data, formData } = props;
  const { chartData, chartUniqueId } = data || {};
  const { blocks, selectedDataModel, workflowId, workflowEnable, ContractsdataElement, LinkedContractsdataElements, PortfolioInfo, VendorInfo, LinkedObligationdataElements, topHeaderdataElements, LinkedSpenddataElements, isCommentSectionEnable, isLinked, isSideBar, sidebar } = chartData || {};
  const currentDocumentId = props?.match?.params?.id;
  const [json, setJson] = useState({});
  const [blockState, setBlockState] = useState(json)
  const [enabledBlocks, setEnabledBlocks] = useState([])
  const [currentDataModel, setCurrentDataModel] = useState({})
  const [accordionSupport, setAccordionSupport] = useState({})
  const [tableData, setTableData] = useState({});
  const [activeTab, setActiveTab] = useState('contract');
  const [enableEdit, setEnableEdit] = useState(false)
  const [auditTrail, setAuditTrail] = useState([])
  const [attachments, setAttachments] = useState([])
  const [activeTabMain, setActiveTabMain] = useState('clause');
  const classes = useStyles();

  const selectedStep = {
    dataModel: selectedDataModel,
    blocks: blocks
  }

  const stableBlocks = useMemo(() => blocks, [JSON.stringify(blocks)]);

  useEffect(() => {
    console.log("b**ObligationViewer", blocks)
    if (selectedStep?.blocks?.length) {
      let accordion = {};
      let b = selectedStep.blocks.filter((block => {
        if (block.accordion) {
          accordion[block.name] = block.accordion
        }
        return block.enable
      }))
      setEnabledBlocks(b)
      setAccordionSupport(accordion)
      getWorkflow(workflowId)
      fetchDataModel()
      getAllAttachmentsOfOpportunity()
      fetchSingleObligation()
      props.getAuditTrailsData({
        dataModelId: selectedDataModel,
        appId: props.match.params.appid,
        documentId: props.match.params.id,
        dataUniqueId: chartUniqueId + '_audit_Trails_Obligations'
      })
    }
  }, [stableBlocks])

  const clearCurrentChartReduxStore = () => {
    let subKeys = [
      props.data.chartUniqueId + '_execute_obligation_Workflow',
      props.data.chartUniqueId + '_Obligations_Next_Respondent',
      props.data.chartUniqueId + '_obligation_executeWorkflow_reject',
      props.data.chartUniqueId + '_Obligations_Step_Assigning_Upated',
      props.data.chartUniqueId + '_Current_Steps_Members',
      props.data.chartUniqueId + '_getsingleobligation',
      props.data.chartUniqueId + '_audit_Trails_Obligations',
      props.data.chartUniqueId + '_documentsfromIds',

    ]
    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: subKeys
    })
  }


  useEffect(() => {

    return (() => {
      clearCurrentChartReduxStore()
    })
  }, [])

  useEffect(() => {
    if (props.formData?.auditTrails?.[chartUniqueId + '_audit_Trails_Obligations']) {
      let obj = props.formData?.auditTrails[chartUniqueId + '_audit_Trails_Obligations'] || {}
      setAuditTrail(obj)
    }
  }, [props.formData?.auditTrails?.[chartUniqueId + '_audit_Trails_Obligations']])

  const getAuditTrailsData = () => {
    props.getAuditTrailsData({
      dataModelId: selectedDataModel,
      appId: props.match.params.appid,
      documentId: props.match.params.id,
      dataUniqueId: chartUniqueId + '_audit_Trails_Obligations'
    })
  }
  useEffect(() => {
    if (props.formData?.document[chartUniqueId + '_getsingleobligation']) {
      getAuditTrailsData()
      let obj = props.formData?.document[chartUniqueId + '_getsingleobligation'] || {}
      if (obj['workflow']) {
        fetchTasks(workflowId, obj['workflow']?.id)
      }
      setJson(obj);
      filterDocIds(obj)
      setBlockState(obj)
    }
  }, [props.formData?.document[chartUniqueId + '_getsingleobligation']])

  const fetchTasks = (workflowId, currentTaskId) => {
    if (currentTaskId && workflowId) {
      let payload = {
        workflowId: workflowId,
        currentTaskId: currentTaskId,
        appId: props.match.params.appid,
        dataUniqueId: chartUniqueId + '_obligation_next_step',
        data: {
          docId: props.match.params.id,
          dmId: selectedDataModel
        }
      }
      props.getNextTasks(payload)
    }
  }
  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const filterDocIds = (res) => {
    let linkedData = res[ContractsdataElement] || [];
    let docIdsList = []
    linkedData && linkedData.length && linkedData.forEach(obj => {
      if (obj.dataModel) {
        docIdsList = obj.documents;
      }
    });
    if (linkedData.length > 0) {
      getDocsfromIds(docIdsList, linkedData?.[0]?.dataModel)
    }

  }

  const getDocsfromIds = (docIdsList, dataModel) => {
    if (docIdsList && docIdsList.length > 0) {
      const fields = [...LinkedContractsdataElements.map(i => i.value), PortfolioInfo, VendorInfo].join(',');
      let payload = {
        fields,
        docIds: docIdsList,
        appId: props.match.params.appid,
        id: dataModel
      };
      if (!props.formData?.document[chartUniqueId + '_documentsfromIds']) {
        props.getDocumentsFromIDsOfOpportunity({ ...payload, dataUniqueId: chartUniqueId + '_documentsfromIds' });
      }

    }
  }

  useEffect(() => {
    if (formData?.document[chartUniqueId + '_documentsfromIds']?.length) {
      let dataList = formData?.document[chartUniqueId + '_documentsfromIds'] || []
      setTableData(dataList)
    }
  }, [props.formData?.document[chartUniqueId + '_documentsfromIds']])

  useEffect(() => {
    const updatedData = props.formData?.document?.[`${chartUniqueId}_rejected_obligation`];
    if (updatedData) {
      toast.success(updatedData?.message || 'This Obligation is Rejected')
      props.clearReduxDataOfCurrentComponent({
        key: 'document',
        subKey: [`${chartUniqueId}_rejected_obligation`]
      })
      fetchSingleObligation();
    }
  }, [props.formData?.document?.[`${chartUniqueId}_rejected_obligation`]])

  useEffect(() => {
    const updatedData = props.formData?.document?.[`${chartUniqueId}_accepted_obligation`];
    if (updatedData) {
      toast.success(updatedData?.message || 'This Obligation is Accepted')
      props.clearReduxDataOfCurrentComponent({
        key: 'document',
        subKey: [`${chartUniqueId}_accepted_obligation`]
      })
      fetchSingleObligation();
    }
  }, [props.formData?.document?.[`${chartUniqueId}_accepted_obligation`]])


  const getWorkflow = (workflowId) => {
    let payload = {
      id: workflowId,
      dataUniqueId: `${chartUniqueId}_obligation_workflows`,
      appId: props.match.params.appid,
    }
    props.getWorkflowById(payload)
  }

  const fetchSingleObligation = () => {
    if (!props.formData?.document[chartUniqueId + '_getsingleobligation']) {
      let payload = fetchSingleObligationPayload(props.appId, props.orgId, selectedStep, props.match.params.id, chartUniqueId)
      props.getSingleOpportunity(payload)
    }
  }

  const fetchDataModel = () => {
    let payload = {
      appid: props.appId,
      orgId: props.orgId
    }
    if (selectedStep?.dataModel) {
      if (!formData?.dataModel?.[selectedStep.dataModel]) {
        if (!formData?.dataModel?.[selectedStep.dataModel] && !formData[`${selectedStep.dataModel}_loading`]) {
          payload['dataModelId'] = selectedStep.dataModel
          payload['dataUniqueId'] = selectedStep.dataModel
          props.getDataModelById(payload)
        }
      } else {
        setCurrentDataModel(formData?.dataModel?.[selectedStep.dataModel])
      }
    }
  }

  const handleOnChange = (name, value, type, uiFieldType, header, valueObj) => {
    setEnableEdit(true);
    let v = value;
    if (header?.type === 'namepicker' && valueObj) {
      v = {
        id: valueObj?._id,
        name: valueObj?.name
      }
    }

    if (header?.type == 'comments') {
      setCommentTypeFieldState({
        ...commentTypeFieldState,
        [header.value || header.name]: v
      })
    } else {
      setBlockState({
        ...blockState,
        [name]: v
      })
    }
  }

  const handleCheckboxChange = (name, value) => {
    setBlockState(prevBlockState => ({
      ...prevBlockState,
      [name]: [value]
    }));
  };

  const onRejectObligation = () => {
    let payload = {
      dataUniqueId: `${chartUniqueId}_rejected_obligation`,
      obligationId: props.match.params.id,
      dataModelId: selectedDataModel,
      appId: props.appId,
      data: {
        status: 'Rejected'
      },
      orgId: props.orgId
    }
    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: [`${chartUniqueId}_getsingleobligation`]
    })
    props.rejectedWorkFlowObligations(payload)
  }

  const completedWorkFlowObligations = () => {
    let payload = {
      dataUniqueId: `${chartUniqueId}_completed_obligation`,
      obligationId: props.match.params.id,
      dataModelId: selectedDataModel,
      appId: props.appId,
      data: {
        status: 'Completed'
      },
      orgId: props.orgId
    }
    props.completedWorkFlowObligations(payload)

  }

  const onAcceptObligation = () => {
    let payload = {
      dataUniqueId: `${chartUniqueId}_accepted_obligation`,
      obligationId: props.match.params.id,
      dataModelId: selectedDataModel,
      appId: props.appId,
      data: {
        workFlowId: workflowId
      },
      orgId: props.orgId
    }
    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: [`${chartUniqueId}_getsingleobligation`]
    })
    props.acceptWorkFlowObligations(payload)
  }


  const removeIdFields = (obj) => {
    if (Array.isArray(obj)) {
      obj.forEach(removeIdFields);
    } else if (typeof obj === 'object' && obj !== null) {
      if (obj._id) {
        delete obj._id;
      }
      Object.keys(obj).forEach((key) => {
        removeIdFields(obj[key]);
      });
    }
  };
  useEffect(() => {
    if (props.formData?.document[chartUniqueId + '_updateobligation']?._id) {
      let obj = props.formData?.document[chartUniqueId + '_updateobligation'] || {};
      const formattedObj = {};
      for (const key in obj) {
        const value = obj[key];
        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
          formattedObj[key] = value.split('T')[0];
        } else {
          formattedObj[key] = value;
        }
      }

      setJson(formattedObj);
      setBlockState(formattedObj);
    } else {
      console.log('Error in Update Identify Step');
    }
  }, [props.formData?.document[chartUniqueId + '_updateobligation']]);

  const onSaveClick = () => {
    let data = JSON.parse(JSON.stringify(blockState))
    removeIdFields(data)
    let formData = {
      appId: props.appId,
      dataModelId: chartData?.selectedDataModel,
      dataUniqueId: props.data.chartUniqueId + '_updateobligation',
      opportunityId: props.match.params.id,
      payload: data,
    }
    props.updateOpportunity(formData)
  }

  const handleSave = () => {
    setEnableEdit(false)
    onSaveClick()
  }

  const getAllAttachmentsOfOpportunity = () => {
    const payload = {
      appId: props.appId,
      orgId: props.orgId,
      dataModelId: chartData?.selectedDataModel,
      subDataModelId: "66bce0fff8564d20d71259cc",
      opportunityId: props.match.params.id,
      dataUniqueId: `${chartUniqueId}_uploaded_lists_file`
    };
    props.getAllActionsOfOpportunity(payload);
  }

  useEffect(() => {
    const list = props.formData?.document?.[`${chartUniqueId}_uploaded_lists_file`];
    if (list) {
      setAttachments(list)
    }
  }, [props.formData?.document?.[chartUniqueId + '_uploaded_lists_file']])

  console.log('attachments**ObligationViewer', props)

  return (

    (props.formData?.[chartUniqueId + '_getsingleobligation_loading'] || props.formData?.[chartUniqueId + '_updateobligation_loading'] || props.formData?.[chartUniqueId + '_accepted_obligation_loading'] || props.formData?.[chartUniqueId + '_rejected_obligation_loading']) ? props.loader : (
      <div className={classes.container}>
        <Grid container className={classes.headerGrid}>
          <Grid item xs={12} className={classes.headerRow}>
            <TopHeaderViewer {...props} setActiveTabMain={setActiveTabMain} activeTabMain={activeTabMain} blockState={blockState} />
          </Grid>
          {
            blockState?.['status'] === 'Rejected' && (
              <div style={{ paddingBottom: '12px' }}>
                <Alert severity="error" variant="filled" classes={{ root: classes.alertRoot, message: classes.message, icon: classes.icon }}>
                  {`This document has been rejected by ${blockState?.['rejectedBy']?.name}.`}
                </Alert>
              </div>
            )
          }
          <Grid container>
            {
              (
                <Grid item xs={12} md={sidebar?.isSideBar ? 8 : 12} className={`${classes.main} ${classes.mainCol} myScrollContainer`}>
                  {activeTabMain === 'clause' && (
                    <div className={classes.clauseWrap}>
                      <StepLevelBlocksViewer
                        {...props}
                        currentDocumentId={currentDocumentId}
                        blocks={enabledBlocks}
                        selectedStep={selectedStep}
                        blockState={blockState}
                        handleSave={handleSave}
                        currentDataModel={currentDataModel}
                        accordionSupport={accordionSupport}
                        setAccordionSupport={setAccordionSupport}
                        onChange={handleOnChange}
                        enableEdit={enableEdit}
                        handleCheckboxChange={handleCheckboxChange}
                        enableWorkflow={typeof workflowEnable !== 'undefined' ? workflowEnable : false}
                        onRejectObligation={onRejectObligation}
                        isCommentSectionEnable={isCommentSectionEnable}
                        onAcceptObligation={onAcceptObligation}
                        isLinked={isLinked}
                        fetchSingleObligation={fetchSingleObligation}
                        completedWorkFlowObligations={completedWorkFlowObligations}
                        enableRejectButton={blockState?.actions?.length ? true : false}
                        nextStep={formData?.document?.[chartUniqueId + '_obligation_next_step'] ? formData?.document?.[chartUniqueId + '_obligation_next_step'] : {}}
                        CurrentObligationWorkflow={blockState?.workflow ? blockState?.workflow : {}}
                        obligationWorkflowObject={props.formData?.document[chartUniqueId + '_obligation_workflows'] ? (props.formData?.document[chartUniqueId + '_obligation_workflows']?.['diagram']?.['steps']) : []}
                      />
                    </div>
                  )}
                  {activeTabMain === 'audit' && (
                    <AuditTrailViewer {...props} auditTrail={auditTrail} chartUniqueId={chartUniqueId} />
                  )}
                </Grid>
              )
            }

            {/* <Grid item xs={12} md={4}>
            {(props.formData?.[chartUniqueId + '_documentsfromIds_loading'] || props.formData?.[`${selectedStep.dataModel}_loading`])
              ? props.loader
              : (
                <SideBarViewer
                  {...props}
                  onSaveClick={onSaveClick}
                  blockState={blockState}
                  removeIdFields={removeIdFields}
                  setActiveTab={setActiveTab}
                  activeTab={activeTab}
                  tableData={tableData}
                  sideBar={props.data.chartData.sidebar}
                  topHeaderdataElements={topHeaderdataElements ? topHeaderdataElements : []}
                />
              )}
          </Grid> */}
            {sidebar && sidebar?.isSideBar && (
              <Grid item xs={12} md={4}>
                {(props.formData?.[chartUniqueId + '_documentsfromIds_loading'] || props.formData?.[`${selectedStep.dataModel}_loading`])
                  ? props.loader
                  : (
                    <SideBarViewer
                      {...props}
                      blockState={blockState}
                      setActiveTab={setActiveTab}
                      onSaveClick={onSaveClick}
                      removeIdFields={removeIdFields}
                      LinkedContractsdataElements={LinkedContractsdataElements}
                      sideBar={props.data.chartData.sidebar}
                      activeTab={activeTab}
                      tableData={tableData}
                      attachments={attachments}
                      topHeaderdataElements={topHeaderdataElements ? topHeaderdataElements : []}
                    />
                  )}
              </Grid>
            )}
          </Grid>
        </Grid>
      </div>
    )

  );
};

export default ObligationViewer;
